import { createFileRoute, notFound } from '@tanstack/react-router';
import { isImportSlug } from '@aslen/core';
import { ImportWizard } from '@/features/import/import-wizard';

/**
 * W-31c/d — the import wizard, its own route so the parser, the templates and
 * the preview table stay out of the initial bundle (autoCodeSplitting).
 */
export const Route = createFileRoute('/_app/import/$kind/')({
  beforeLoad: ({ params }) => {
    if (!isImportSlug(params.kind)) throw notFound();
  },
  component: function Import() {
    const { kind } = Route.useParams();
    if (!isImportSlug(kind)) return null;
    return <ImportWizard slug={kind} />;
  },
});
